import { render } from "./legoFloatingButton.vue?vue&type=template&id=70895778"
import script from "./legoFloatingButton.vue?vue&type=script&lang=js"
export * from "./legoFloatingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoFloatingButton/legoFloatingButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70895778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70895778', __exports__)) {
    api.reload('70895778', __exports__)
  }
  
  module.hot.accept("./legoFloatingButton.vue?vue&type=template&id=70895778", () => {
    api.rerender('70895778', render)
  })

}


export default __exports__